import axiosClient from "utils/api";
const URI = "/drive/trash";

export const getTrashFilesFolders = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get trash files and folder:", error);
    throw error;
  }
};

export const emptyTrash = async () => {
  const URL = `${URI}/empty`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during empty Trash :", error);
    throw error;
  }
};
